<template>
     <vs-dialog scroll overflow-hidden v-model="active">
        <template #header>
          <h3>
          </h3>
        </template>
        <div class="con-content">
          <vs-row class="mt-4">
                <h5>¿Esta seguro de eliminar la domicilización de este cargo?</h5>
          </vs-row>
        </div>
        <template #footer>
            <div class="d-flex">
                <vs-button
                    danger
                    @click="active = false"
                    style="width: 45%;"
                >
                    Cancelar
                </vs-button>
                <vs-button
                    success
                    class="ml-auto"
                    @click="getCancelar(rows)"
                    style="width: 45%;"
                >
                    Guardar
                </vs-button>
            </div>
        </template>
     </vs-dialog>
</template>

<script>
import domicializacion from '../../../../api/requests/domicializacion.js'
export default {
    props:[
      'value',
      'rows',
      'personaId',
    ],
    data () {
        return {
            active: false,
        }
    },
    created(){
        this.getCuentaGuardad()
    },
    methods: {
        async getCancelar(info){
            try {
                const response = await domicializacion.getCancelar(info.movimiento_id)
                this.$emit('refreshTable')
                this.active = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    title: 'Operación éxitosa'
                })
                this.cuentaGuardada = response.data.cuentas_bancarias
            } catch (error) {
                this.active = false
            }

        },
        async getCuentaGuardad() {
            try {
                const response = await domicializacion.getCuentaGuardad(this.personaId)
                this.cuentaGuardada = response.data.cuentas_bancarias
            } catch (error) {

            }
        },
    },
    watch: {
        value (val) {
            this.active = val
        },
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}

.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd
}

.greyColor {
  color: gray
}

.greyOscuro {
  color: rgb(78, 78, 78);
  font-weight: bold;
}

.vs-select__option.activeOption {
    background: rgba(var(--vs-color), 0.05);
    color: rgba(var(--vs-color), 1);
    pointer-events: all;
}

</style>

<style>


.domicializar .vs-dialog{
    max-width: 95% !important;
}
</style>